const id = {
  menuMakerChecker: "Maker/Checker",
  menuSettingMakerChecker: "Atur Maker/Checker",
  menuListMakerChecker: "Daftar Pengesahan",
  menuMakerCheckerSettingTitle: "Pengaturan Maker/Checker",
  menuMakerCheckerSettingDesc:
    "Kamu bisa mengatur tugas dan peran anggota tim kamu sebagai Maker/Checker.",
  makerCheckerButton: "Tambahkan Akun",
  makerCheckerSetting: "Daftar Akun Maker/Checker",
  makerCheckerSettingDesc:
    "Pilih akun yang sudah terdaftar untuk dijadikan Maker/Checker.",
  makerCheckerFilterName: "Cari nama atau email",
  makerCheckerFilterRole: "Filter berdasarkan posisi",
  makerCheckerTableName: "Nama",
  makerCheckerTableEmail: "Email",
  makerCheckerTablePosition: "Posisi",
  makerCheckerTableActions: "Aksi",
  makerCheckerEmptyTitle: "Tidak ada data",
  makerCheckerEmptyContent:
    "Tidak ada data yang telah ditambahkan. Kamu dapat menambahkan kapan saja.",
  makerCheckerSuccessMsg: "Data berhasil ditambahkan",
  makerCheckerRegisterTitle: "Daftarkan Akun",
  makerCheckerRegisterEmailLabel: "Email Terdaftar",
  makerCheckerRegisterAccountNameLabel: "Nama Akun",
  makerCheckerRegisterAccountMediaTypeLabel: "Tipe Media",
  makerCheckerRegisterAccountPosisi: "Posisi",
  makerCheckerRegisterAccountPositionPlaceholder: "Pilih posisi",
  makerCheckerRegisterAccountPositionMaker: "Maker",
  makerCheckerRegisterAccountPositionChecker: "Checker",
  makerCheckerRegisterAccountPositionMakerChecker: "Maker & Checker",
  makerCheckerRegisterButton: "Daftar",
  makerCheckerEmailPlaceholder: "Pilih dari daftar email yang sudah terdaftar",
  makerCheckerMediaTypePlaceholder: "Pilih tipe media",
  emailRequired: "Email wajib diisi",
  emailInvalid: "Email tidak valid",
  nameMinLength: "Nama minimal 2 karakter",
  nameRequired: "Nama wajib diisi",
  mediaTypeRequired: "Tipe media wajib diisi",
  positionRequired: "Posisi wajib dipilih",
  makerCheckerEditTitle: "Edit Akun",
  makerCheckerUpdateButton: "Update",
  makerCheckerConfirmRegisterTitle: "Apakah data sudah sesuai?",
  makerCheckerConfirmRegisterContent:
    "Email yang sudah terdaftar tidak dapat diubah, namun posisi akun dapat diubah sewaktu-waktu.",
  makerCheckerConfirmUpdateTitle: "Apakah perubahan data sudah sesuai?",
  makerCheckerConfirmUpdateContent:
    "Pastikan data yang diubah sudah sesuai dengan yang diinginkan.",
  makerCheckerConfirmDeleteTitle: "Menon-aktifkan Akun",
  makerCheckerConfirmDeleteContent:
    "Akun yang dinon-aktifkan tidak akan dapat digunakan untuk pengesahan/pembuatan pesan.",
  makerCheckerDeactivateSuccessMsg: "Akun {0} berhasil dinon-aktifkan",
  makerCheckerUpdateSuccessMsg: "Akun {0} berhasil diubah",
  makerCheckerConfirmStatusTitle: "Apakah anda yakin?",
  makerCheckerStatusActivate: "Aktifkan",
  makerCheckerStatusDeactivate: "Non-aktifkan",
  makerCheckerStatusActive: "Aktif",
  makerCheckerStatusInactive: "Non-aktif",
  makerCheckerConfirmStatusContent: "Kamu akan {0} akun {1}?",

  makerCheckListTitle: "Daftar Pengesahan",
  makerCheckListDesc:
    "Kamu bisa melakukan pengesahan berdasarkan daftar dibawah ini.",
};

const en = {
  menuMakerChecker: "Maker/Checker",
  menuSettingMakerChecker: "Manage Maker/Checker",
  menuListMakerChecker: "Approval Queue",
  menuMakerCheckerSettingTitle: "Maker/Checker Settings",
  menuMakerCheckerSettingDesc:
    "Manage team members' roles and tasks as Maker or Checker.",
  makerCheckerButton: "Add Account",
  makerCheckerSetting: "Maker/Checker Accounts",
  makerCheckerSettingDesc:
    "Select an existing account to assign as Maker/Checker.",
  makerCheckerFilterName: "Search by name or email",
  makerCheckerFilterRole: "Filter by position",
  makerCheckerTableName: "Name",
  makerCheckerTableEmail: "Email",
  makerCheckerTablePosition: "Position",
  makerCheckerTableActions: "Actions",
  makerCheckerEmptyTitle: "No Data Available",
  makerCheckerEmptyContent:
    "No data has been added. You can provide details at any time.",
  makerCheckerSuccessMsg: "Data added successfully",
  makerCheckerRegisterTitle: "Register Account",
  makerCheckerRegisterEmailLabel: "Registered Email",
  makerCheckerRegisterAccountNameLabel: "Account Name",
  makerCheckerRegisterAccountMediaTypeLabel: "Media Type",
  makerCheckerRegisterAccountPosisi: "Position",
  makerCheckerRegisterAccountPositionPlaceholder: "Select position",
  makerCheckerRegisterAccountPositionMaker: "Maker",
  makerCheckerRegisterAccountPositionChecker: "Checker",
  makerCheckerRegisterAccountPositionMakerChecker: "Maker & Checker",
  makerCheckerRegisterButton: "Register",
  makerCheckerEmailPlaceholder: "Select from registered emails",
  makerCheckerMediaTypePlaceholder: "Select media type",
  emailRequired: "Email is required",
  emailInvalid: "Email is invalid",
  nameMinLength: "Name must be at least 2 characters",
  nameRequired: "Name is required",
  mediaTypeRequired: "Media type is required",
  positionRequired: "Position is required",
  makerCheckerEditTitle: "Edit Account",
  makerCheckerUpdateButton: "Update",
  makerCheckerConfirmRegisterTitle: "Confirm new account data",
  makerCheckerConfirmRegisterContent:
    "Registered email cannot be changed, but the account position can be changed at any time.",
  makerCheckerConfirmUpdateTitle: "Confirm changes",
  makerCheckerConfirmUpdateContent: "Please ensure the changes are correct.",
  makerCheckerConfirmDeleteTitle: "Deactivate Account",
  makerCheckerConfirmDeleteContent:
    "A deactivated account cannot be used for maker-checker actions.",
  makerCheckerDeactivateSuccessMsg: "Account {0} has been deactivated",
  makerCheckerUpdateSuccessMsg: "Account {0} has been updated",
  makerCheckerConfirmStatusTitle: "Are you sure?",
  makerCheckerStatusActivate: "Activate",
  makerCheckerStatusDeactivate: "Deactivate",
  makerCheckerStatusActive: "Active",
  makerCheckerStatusInactive: "Inactive",
  makerCheckerConfirmStatusContent: "You are about to {0} the account {1}.",

  makerCheckListTitle: "Approval List",
  makerCheckListDesc: "You can verify the list below.",
};

export default { id, en };
